
import {
  Message,
  MessageBox
} from 'element-ui'
import i18n from '@/i18n/i18n';

let errorList = i18n.t('error')

// 错误长度比较大 MessageBox
let errorFromService = [
  '800F1002',

]
// 错误长度比较大 Message
let errorFromServiceShort =[

]

export function handleError (err) {
  let isExit = ''
  let flag = false
  for (let key in errorList) {
    if (err.Errors[0].Code === key) {
      isExit = errorList[key]
      break
    }
  }
  for (let per of errorFromService) {
    if (per === err.Errors[0].Code) {
      isExit = err.Errors[0].Message
      // 通过flag 控制 使用哪种弹框
      // flag = true
      break
    }
  }
  if (isExit) {
    if (flag) {
      MessageBox.alert(isExit, '异常提示', {
        confirmButtonText: '关闭',
        customClass: 'errorBox'
        // type: 'error'
      })
    } else {
      Message.error({
        message: isExit,
        customClass: 'messageErr',
        type: 'error'
      })
    }
  }
}

export default errorList



// WEBPACK FOOTER //
// ./src/public/error-info.js